import {getDataInLocalStorage} from "@/utils/localStorage";

// 「组学智能体 Pro」宣传弹窗的“不再提示”记录：按 用户 + 平台 维度存在本地
const KEY_PREFIX = 'chatAiPromoHidden'

function getCurrentUid() {
    try {
        const user = JSON.parse(getDataInLocalStorage('user') || '{}')
        return user.uid || user.id || ''
    } catch (e) {
        return ''
    }
}

function buildKey(platform) {
    return `${KEY_PREFIX}:${getCurrentUid()}:${platform}`
}

export function isChatAiPromoHidden(platform) {
    try {
        return window.localStorage.getItem(buildKey(platform)) === '1'
    } catch (e) {
        return false
    }
}

export function hideChatAiPromo(platform) {
    try {
        window.localStorage.setItem(buildKey(platform), '1')
    } catch (e) {
        // 本地存储不可用时忽略，仅本次生效
    }
}
